<template>
  <div v-if="ready" class="details">
    <AppHeader :title="tier.name" :items="menu" :backButton="{
      container: 'app',
      page: 'Tiers'
    }" />
    <v-container class="pl-3 pr-3 pb-3" fluid grid-list-xl>
      <Informations v-if="$route.params.type === 'informations'" :tier="tier" />
    </v-container>
  </div>
</template>

<script>
import AppHeader from '@/components/ui/AppHeader.vue'
import Informations from './components/details/Informations.vue'
import { getTier } from '@/services/containers/app/tiers'

export default {
  name: 'Details',
  components: {
    AppHeader,
    Informations
  },
  data: () => ({
    tier: {},
    menu: [
      {
        title: 'Informações',
        value: 'informations',
        icon: 'dashboard',
        show: () => true
      },
    ],
    ready: false
  }),
  async created() {
    await this.fetchTier()
  },
  methods: {
    async fetchTier() {
      this.$showLoading()
      try {
        const { id } = this.$route.params
        const { data } = await getTier(id)
        this.tier = data
        this.ready = true
      } catch (error) {
        this.$hideLoading()
        this.ready = true
        this.$toast(error.response.data.message, 'red')
      } finally {
        this.$hideLoading()
      }
    }
  }
}

</script>